import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import { Notebook as NotebookIcon } from 'common/icons'
import {
  getContentHasVariants,
  getElementHasVariants,
  getIsOptimized,
} from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'
import { VariantStatus } from '../../manage/utils/variantUtils'

type Props = {
  statusFilter: VariantStatus
  hasLoadingVariants?: boolean
  tooltipPlacement: 'top' | 'left'
  showInputResultsButton?: boolean
  onInputResultsClick?: () => void
}

const IconsBase = ({
  statusFilter,
  hasLoadingVariants = false,
  tooltipPlacement,
  showInputResultsButton,
  onInputResultsClick,
}: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()
  const hasVariants = getContentHasVariants(content)
  const isOptimized = getIsOptimized(selectedElement)
  const hasElementVariants = getElementHasVariants(selectedElement)

  return (
    <>
      {selectedElement && hasVariants && (
        <div className="flex items-stretch">
          <ExportMenuButton
            tooltipPlacement={tooltipPlacement}
            statusFilter={statusFilter}
            disabled={hasLoadingVariants}
          />
        </div>
      )}
      {showInputResultsButton && isOptimized && hasElementVariants && (
        <ButtonWithTooltip
          data-testid="input-results-button"
          variant="icon"
          tooltip
          tooltipText="Input Results"
          placement={tooltipPlacement}
          prefixIcon={
            <NotebookIcon
              size={6}
              isDefaultColor={false}
              className="text-gold-600 cursor-pointer hover:text-gold-700"
            />
          }
          onClick={onInputResultsClick}
        />
      )}
    </>
  )
}

export default IconsBase
